import { render, staticRenderFns } from "./TargetGroupAds.vue?vue&type=template&id=81c5c9e6&scoped=true&"
import script from "./TargetGroupAds.vue?vue&type=script&lang=js&"
export * from "./TargetGroupAds.vue?vue&type=script&lang=js&"
import style0 from "./TargetGroupAds.vue?vue&type=style&index=0&lang=css&"
import style1 from "./TargetGroupAds.vue?vue&type=style&index=1&id=81c5c9e6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81c5c9e6",
  null
  
)

export default component.exports